/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('contact');
const CONTACT_LIST = "CONTACT_LIST";
const CONTACT_ADD = "CONTACT_ADD";
const CONTACT_DELETE = "CONTACT_DELETE";
const CONTACT_EDIT = "CONTACT_EDIT";
const CONTACT_DETAIL = "CONTACT_DETAIL";

export default {
    CONTACT_LIST,
    contactList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:CONTACT_LIST,
                data
            })
        })
    },
    CONTACT_ADD,
    contactAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:CONTACT_ADD,
                data
            })
        })
    },
    CONTACT_DELETE,
    contactDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:CONTACT_DELETE,
                data,
            })
        })
    },
    CONTACT_EDIT,
    contactEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:CONTACT_EDIT,
                data,
            })
        })
    },
    CONTACT_DETAIL,
    contactDetail:(id)=>{
        if(typeof id == 'object') {
            return {
                type:CONTACT_DETAIL,
                data:id
            };
        }else {
            return ajaxCommon({
                api:TheApi('get')(id),
                success:(data)=>({
                    type:CONTACT_DETAIL,
                    data,
                })
            })
        }
    },
}



// WEBPACK FOOTER //
// ./src/actions/ContactAction.js